// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/clear_generation_crop.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/clear_generation_crop.proto.
 */
export const file_vision_generations_v1_clear_generation_crop: GenFile = /*@__PURE__*/
  fileDesc("CjF2aXNpb24vZ2VuZXJhdGlvbnMvdjEvY2xlYXJfZ2VuZXJhdGlvbl9jcm9wLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIo4BChpDbGVhckdlbmVyYXRpb25Dcm9wUmVxdWVzdBJPCgZwYXJhbXMYASABKAsyPy5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkNsZWFyR2VuZXJhdGlvbkNyb3BSZXF1ZXN0LlBhcmFtcxofCgZQYXJhbXMSFQoNZ2VuZXJhdGlvbl9pZBgBIAEoCSK9AQobQ2xlYXJHZW5lcmF0aW9uQ3JvcFJlc3BvbnNlElAKBnJlc3VsdBgBIAEoCzJALnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuQ2xlYXJHZW5lcmF0aW9uQ3JvcFJlc3BvbnNlLlJlc3VsdBpMCgZSZXN1bHQSQgoKZ2VuZXJhdGlvbhgBIAEoCzIuLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuVmlzaW9uR2VuZXJhdGlvbmIGcHJvdG8z", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationCropRequest
 */
export type ClearGenerationCropRequest = Message<"protos.vision.generations.v1.ClearGenerationCropRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearGenerationCropRequest.Params params = 1;
   */
  params?: ClearGenerationCropRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationCropRequest.
 * Use `create(ClearGenerationCropRequestSchema)` to create a new message.
 */
export const ClearGenerationCropRequestSchema: GenMessage<ClearGenerationCropRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_crop, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationCropRequest.Params
 */
export type ClearGenerationCropRequest_Params = Message<"protos.vision.generations.v1.ClearGenerationCropRequest.Params"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationCropRequest.Params.
 * Use `create(ClearGenerationCropRequest_ParamsSchema)` to create a new message.
 */
export const ClearGenerationCropRequest_ParamsSchema: GenMessage<ClearGenerationCropRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_crop, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationCropResponse
 */
export type ClearGenerationCropResponse = Message<"protos.vision.generations.v1.ClearGenerationCropResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ClearGenerationCropResponse.Result result = 1;
   */
  result?: ClearGenerationCropResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationCropResponse.
 * Use `create(ClearGenerationCropResponseSchema)` to create a new message.
 */
export const ClearGenerationCropResponseSchema: GenMessage<ClearGenerationCropResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_crop, 1);

/**
 * @generated from message protos.vision.generations.v1.ClearGenerationCropResponse.Result
 */
export type ClearGenerationCropResponse_Result = Message<"protos.vision.generations.v1.ClearGenerationCropResponse.Result"> & {
  /**
   * @generated from field: protos.vision.generations.v1.VisionGeneration generation = 1;
   */
  generation?: VisionGeneration | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ClearGenerationCropResponse.Result.
 * Use `create(ClearGenerationCropResponse_ResultSchema)` to create a new message.
 */
export const ClearGenerationCropResponse_ResultSchema: GenMessage<ClearGenerationCropResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_clear_generation_crop, 1, 0);

